import { ExclamationIcon } from "@heroicons/react/outline";
import React from "react";

interface Props {
  show: boolean;
  text?: string;
}

const InlineWarning: React.FC<Props> = ({
  show,
  text = "Warning: No response was generated for this call. Try adjusting your prompt and parameters.",
}) => {
  if (!show) {
    return null;
  }

  return (
    <span className="mt-2 flex items-center rounded px-3  text-sm italic text-gray-500">
      <ExclamationIcon className="mr-2 h-4 w-4 flex-shrink-0 text-yellow-500" aria-hidden="true" />
      {text}
    </span>
  );
};

export default InlineWarning;
